import { Box, Chip, Typography } from '@mui/material';
import { Modality } from '~/domain/dicom/modality';

export default function ModalitySelect({
    modality,
    setModality,
}: {
    modality: Modality[];
    setModality: (modality: Modality[]) => void;
}) {
    const availableModalities: Modality[] = [Modality.CT, Modality.MR];

    const handleSelectModality = (mod: Modality) => {
        setModality(modality[0] === mod ? [] : [mod]);
    };

    return (
        <Box display="flex" gap={0.5} alignItems="center">
            <Typography fontSize={12}>Modality:</Typography>
            {availableModalities.map((mod) => (
                <Chip
                    key={mod}
                    label={mod}
                    variant="tag"
                    size="small"
                    color={modality[0] === mod ? 'primary' : 'default'}
                    onClick={() => handleSelectModality(mod)}
                />
            ))}
        </Box>
    );
}
